import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { LoginPage } from "../pages/login.page";
import { routes } from "./routes";
import { DashboardPage } from "../pages/dashboard.page";
import { SignedInRoute } from "./signed-in-route";
import { SignedOutRoute } from "./signed-out-route";
import { RequireBoot } from "./require-boot";
import { ScrollToTop } from "./scroll-to-top";
import { ErrorPage } from "../pages/error.page";
import { RoleRoute } from "./role-route";
import { AdminLayout } from "../pages/admin/components/admin-layout";
import { AdminPraxesPage } from "../pages/admin/admin-praxes.page";
import { AdminNewPraxisPage } from "../pages/admin/admin-new-praxis.page";
import { AdminPraxisPage } from "../pages/admin/admin-praxis.page";

const createdRoutes = createRoutesFromElements(
  <Route
    errorElement={<ErrorPage />}
    element={
      <>
        <RequireBoot />
        <ScrollToTop />
      </>
    }
  >
    <Route element={<SignedInRoute />}>
      <Route element={<RoleRoute role="praxis" />}>
        <Route path={routes.dashboard} element={<DashboardPage />} />
        <Route path={routes.download} element={<DashboardPage />} />
      </Route>
      <Route element={<RoleRoute role="admin" />}>
        <Route element={<AdminLayout />}>
          <Route path={routes.admin} element={<AdminPraxesPage />} />
          <Route
            path={routes.adminNewPraxis}
            element={<AdminNewPraxisPage />}
          />
          <Route path={routes.adminPraxis} element={<AdminPraxisPage />} />
        </Route>
      </Route>
    </Route>
    <Route element={<SignedOutRoute />}>
      <Route path={routes.login} element={<LoginPage />} />
    </Route>
  </Route>,
);
export const browserRouter = createBrowserRouter(createdRoutes);
